import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

import { STEPS_LABELS } from './constants';
import { setCurrentStep } from './store/actions/stepper';
import NewImportBackToMappingModal from './new_import_back_to_mapping_modal';
import FilesList from './files-list';
import Preview from './preview/preview';

export function NewImportPreview({ setCurrentStep }) {
  const [showBackToUploadModal, setShowBackToUploadModal] = useState(false);

  const handleBackToUpload = () => {
    setShowBackToUploadModal(true);
  };

  useEffect(() => {
    setCurrentStep(STEPS_LABELS.PREVIEW);
  }, []);

  const renderImportMapping = () => {
    return (
      <Row>
        <Col lg={3} md={3} sm={4} xs={2}>
          <FilesList />
        </Col>
        <Col lg={9} md={9} sm={8} xs={10}>
          <Preview />
        </Col>
      </Row>
    );
  };

  return (
    <React.Fragment>
      <div className="container mt-4 mb-4">
        <a className="js-import-tab" onClick={handleBackToUpload}>
          <FontAwesomeIcon icon={faChevronLeft} />
          <span className="ml-2">Back to mapped data</span>
        </a>
      </div>
      <div className="w-100 d-flex flex-column">
        <div className="container importer-imports imports-index">
          {renderImportMapping()}
        </div>
      </div>
      <NewImportBackToMappingModal
        shown={showBackToUploadModal}
        onClose={setShowBackToUploadModal}
      />
    </React.Fragment>
  );
}

NewImportPreview.propTypes = {
  setCurrentStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setCurrentStep
};

export default connect(null, mapDispatchToProps)(NewImportPreview);
